import * as React from 'react'
import { Button, Well } from '@pushly/aqe/lib/components'
import { useState } from 'react'
import { Descriptions, Skeleton } from 'antd'
import EditPageAnalysisConfigDrawer from '@halo/components/edit-page-analysis-config-drawer/edit-page-analysis-config-drawer'
import { IHydratedPageAnalysisConfig } from '@halo/interfaces/hydrated-page-analysis-config'
import { EditOutlined } from '@ant-design/icons'

export interface IPageAnalysisDetailsTabProps {
    hydratedPageAnalysisConfig: Partial<IHydratedPageAnalysisConfig>
    onUpdate: (update: IHydratedPageAnalysisConfig) => void
}

function PageAnalysisConfigDetailsTab(props: IPageAnalysisDetailsTabProps) {
    const [editPageAnalysisConfig, setEditPageAnalysisConfig] = useState(null)
    const config = props.hydratedPageAnalysisConfig

    return (
        <>
            <Well
                title="Details"
                className="type-3 nested"
                actions={
                    <Button size="small" icon={<EditOutlined />} onClick={() => setEditPageAnalysisConfig(config)}>
                        Edit
                    </Button>
                }
                footerMode="hidden"
            >
                <Skeleton loading={!config} active={true} title={false}>
                    {config && (
                        <Descriptions layout="horizontal" column={1}>
                            <Descriptions.Item label="Name">{config.name}</Descriptions.Item>
                            <Descriptions.Item label="Extends">{config.parent_name || '—'}</Descriptions.Item>
                            <Descriptions.Item label="Associated Domains">
                                {config.associated_domains?.length
                                    ? config.associated_domains.map((ad) => ad.name).join(', ')
                                    : '—'}
                            </Descriptions.Item>
                        </Descriptions>
                    )}
                </Skeleton>
            </Well>

            <EditPageAnalysisConfigDrawer
                pageAnalysisConfig={editPageAnalysisConfig}
                onClose={() => setEditPageAnalysisConfig(null)}
                onUpdate={(updated) => {
                    setEditPageAnalysisConfig(null)
                    props.onUpdate(updated)
                }}
            />
        </>
    )
}

export default PageAnalysisConfigDetailsTab
